import React, { useState, useEffect } from 'react';

const LinkCollector = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState({});

  useEffect(() => {
    // Check if data came via URL parameter
    const params = new URLSearchParams(window.location.search);
    const urlData = params.get('data');
    
    if (urlData) {
      try {
        const newLinks = JSON.parse(decodeURIComponent(urlData));
        // Add to existing links in localStorage
        const existing = JSON.parse(localStorage.getItem('collectedLinks') || '[]');
        const combined = [...existing, ...newLinks];
        localStorage.setItem('collectedLinks', JSON.stringify(combined));
        
        // Clean URL (remove data parameter)
        window.history.replaceState({}, '', '?page=linkCollector');
      } catch (e) {
        console.error('Error parsing URL data:', e);
      }
    }
    
    loadLinks();
    // Auto-refresh every 2 seconds
    const interval = setInterval(loadLinks, 2000);
    return () => clearInterval(interval);
  }, []);

  const loadLinks = () => {
    const stored = localStorage.getItem('collectedLinks');
    if (stored) {
      setLinks(JSON.parse(stored));
    }
  };

  const fetchPersonInfo = async (url, index) => {
    setLoading(prev => ({ ...prev, [index]: true }));
    
    try {
      const webhookUrl = `https://n8n.twodots.cloud/webhook/person-info?url=${encodeURIComponent(url)}`;
      const response = await fetch(webhookUrl);
      const data = await response.json();
      
      // Update the link with person info
      const updated = [...links];
      updated[index] = {
        ...updated[index],
        personInfo: data[0] || data // Handle both array and object responses
      };
      
      localStorage.setItem('collectedLinks', JSON.stringify(updated));
      setLinks(updated);
    } catch (error) {
      console.error('Error fetching person info:', error);
      alert('Failed to fetch person information');
    } finally {
      setLoading(prev => ({ ...prev, [index]: false }));
    }
  };

  const removeLink = (index) => {
    const updated = [...links];
    updated.splice(index, 1);
    localStorage.setItem('collectedLinks', JSON.stringify(updated));
    setLinks(updated);
  };

  const clearAll = () => {
    if (window.confirm('Clear all collected links?')) {
      localStorage.removeItem('collectedLinks');
      setLinks([]);
    }
  };

  const exportLinks = () => {
    const dataStr = JSON.stringify(links, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `collected-links-${new Date().toISOString().split('T')[0]}.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ 
      fontFamily: 'Arial, sans-serif', 
      maxWidth: '900px', 
      margin: '20px auto', 
      padding: '20px',
    }}>
      <div style={{ 
        background: 'rgba(255, 255, 255, 0.05)', 
        padding: '20px', 
        borderRadius: '12px', 
        marginBottom: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <h1 style={{ color: '#fff', display: 'inline-block', margin: 0 }}>
          Collected Links
        </h1>
        <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginLeft: '10px' }}>
          {links.length} links
        </span>
        
        <div style={{ marginTop: '20px' }}>
          <button 
            onClick={clearAll}
            style={{
              background: '#ea4335',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              marginRight: '10px',
              fontSize: '14px'
            }}
          >
            Clear All
          </button>
          <button 
            onClick={exportLinks}
            style={{
              background: '#4285f4',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              marginRight: '10px',
              fontSize: '14px'
            }}
          >
            Export JSON
          </button>
          <button 
            onClick={loadLinks}
            style={{
              background: '#34a853',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Refresh
          </button>
        </div>
      </div>

      {links.length === 0 ? (
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.05)', 
          padding: '40px', 
          borderRadius: '12px',
          textAlign: 'center',
          color: 'rgba(255,255,255,0.6)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h2 style={{ color: '#fff' }}>No links collected yet</h2>
          <p>Use the bookmarklet on Google search results to start collecting!</p>
        </div>
      ) : (
        links.map((link, index) => (
          <div 
            key={index}
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '15px',
              margin: '10px 0',
              borderRadius: '8px',
              borderLeft: '4px solid #B86FFF',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}
          >
            <button
              onClick={() => removeLink(index)}
              style={{
                background: '#ea4335',
                color: '#fff',
                border: 'none',
                padding: '5px 15px',
                borderRadius: '4px',
                cursor: 'pointer',
                float: 'right',
                fontSize: '12px',
                marginLeft: '5px'
              }}
            >
              Remove
            </button>
            
            {/* Extract Info Button - only show for XING/LinkedIn links */}
            {(link.url.includes('xing.com') || link.url.includes('linkedin.com')) && !link.personInfo && (
              <button
                onClick={() => fetchPersonInfo(link.url, index)}
                disabled={loading[index]}
                style={{
                  background: loading[index] ? '#666' : '#B86FFF',
                  color: '#fff',
                  border: 'none',
                  padding: '5px 15px',
                  borderRadius: '4px',
                  cursor: loading[index] ? 'not-allowed' : 'pointer',
                  float: 'right',
                  fontSize: '12px'
                }}
              >
                {loading[index] ? 'Loading...' : 'Extract Info'}
              </button>
            )}
            
            <a 
              href={link.url} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: '#B86FFF',
                textDecoration: 'none',
                fontSize: '16px',
                display: 'block',
                marginBottom: '5px'
              }}
            >
              {link.title}
            </a>
            
            <div style={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: '12px',
              wordBreak: 'break-all'
            }}>
              {link.url}
            </div>
            
            {/* Display Person Info if available */}
            {link.personInfo && (
              <div style={{
                marginTop: '10px',
                padding: '10px',
                background: 'rgba(184, 111, 255, 0.1)',
                borderRadius: '6px',
                border: '1px solid rgba(184, 111, 255, 0.3)'
              }}>
                <div style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
                  📋 Extracted Information
                </div>
                {link.personInfo.name && (
                  <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px' }}>
                    <strong>Name:</strong> {link.personInfo.name}
                  </div>
                )}
                {link.personInfo.location && (
                  <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px' }}>
                    <strong>Location:</strong> {link.personInfo.location}
                  </div>
                )}
                {link.personInfo.role && (
                  <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px' }}>
                    <strong>Role:</strong> {link.personInfo.role}
                  </div>
                )}
                {link.personInfo.company && (
                  <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px' }}>
                    <strong>Company:</strong> {link.personInfo.company}
                  </div>
                )}
              </div>
            )}
            
            {link.timestamp && (
              <div style={{
                color: 'rgba(255,255,255,0.4)',
                fontSize: '11px',
                marginTop: '5px'
              }}>
                Added: {new Date(link.timestamp).toLocaleString()}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default LinkCollector;